export type CasoPlanVencido = 'trial' | 'pagado';

type MostrarFn = (caso: CasoPlanVencido) => void;

let _mostrar: MostrarFn | null = null;

export const planVencidoBridge = {
  register(mostrar: MostrarFn): void {
    _mostrar = mostrar;
  },
  mostrar(caso: CasoPlanVencido): void {
    _mostrar?.(caso);
  },
};
